import { render, staticRenderFns } from "./TicketGate.vue?vue&type=template&id=fbb1637c&scoped=true"
import script from "./TicketGate.vue?vue&type=script&lang=js"
export * from "./TicketGate.vue?vue&type=script&lang=js"
import style0 from "./TicketGate.vue?vue&type=style&index=0&id=fbb1637c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb1637c",
  null
  
)

export default component.exports